import { render, staticRenderFns } from "./productMapping.vue?vue&type=template&id=48ea3174&scoped=true&"
import script from "./productMapping.vue?vue&type=script&lang=js&"
export * from "./productMapping.vue?vue&type=script&lang=js&"
import style0 from "./productMapping.vue?vue&type=style&index=0&id=48ea3174&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ea3174",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('48ea3174')) {
      api.createRecord('48ea3174', component.options)
    } else {
      api.reload('48ea3174', component.options)
    }
    module.hot.accept("./productMapping.vue?vue&type=template&id=48ea3174&scoped=true&", function () {
      api.rerender('48ea3174', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/management/components/productMapping.vue"
export default component.exports